if (!customElements.get('dbs-combi-popup')) {
  customElements.define('dbs-combi-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      this.launcher = this.querySelector('[data-benefits-open]');
      if (!this.dialog?.showModal || !this.launcher) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.launcher.hidden = false;
      this.seenKey = 'dbs-combi-seen-v1';
      this.startKey = 'dbs-combi-start-v1';
      this.launcher.addEventListener('click', () => this.open(this.launcher), options);
      this.querySelectorAll('[data-combi-close]').forEach(button => {
        button.addEventListener('click', () => this.dialog.close(), options);
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        const target = this.previousFocus?.isConnected && this.previousFocus !== document.body ? this.previousFocus : this.launcher;
        target.focus({ preventScroll: true });
      }, options);
      let seen = false;
      let started = Date.now();
      try {
        seen = sessionStorage.getItem(this.seenKey) === '1';
        const savedStart = Number(sessionStorage.getItem(this.startKey));
        if (savedStart > 0 && savedStart <= started) started = savedStart;
        else sessionStorage.setItem(this.startKey, String(started));
      } catch (_) {}
      if (seen || this.dataset.autoOpen !== 'true' || window.Shopify?.designMode) return;
      this.deadline = started + Number(this.dataset.delay || 20) * 1000;
      this.schedule();
      document.addEventListener('visibilitychange', () => this.schedule(), options);
    }
    open(trigger) {
      clearTimeout(this.timer);
      if (this.dialog.open) return;
      this.previousFocus = trigger || document.activeElement;
      this.dialog.showModal();
      this.shown = true;
      try { sessionStorage.setItem(this.seenKey, '1'); } catch (_) {}
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.shown || document.visibilityState !== 'visible') return;
      this.timer = setTimeout(() => this.tryOpen(), Math.max(0, this.deadline - Date.now()));
    }
    tryOpen() {
      if (this.shown || document.visibilityState !== 'visible') return;
      const busy = Array.from(document.querySelectorAll('dialog[open], cart-drawer.active, .menu-drawer-container[open], modal-dialog[open], [role="dialog"][aria-modal="true"]:not([hidden])')).some(element => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).opacity !== '0' && !element.closest('details:not([open])'));
      const editing = document.activeElement?.matches('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]), textarea, select, [contenteditable="true"]');
      if (busy || editing) {
        this.timer = setTimeout(() => this.tryOpen(), 3000);
        return;
      }
      this.open();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
  });
}
